import Vue, { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'

import './popover.sass'

@Component
export class Popover extends Vue {

  @Prop({ required: false, default: 'down' })
  direction: 'up' | 'down'

  render (h: CreateElement) {
    return <div class={'popover-wrapper'}>
      <div class={'popover ' + this.direction}>

        {this.$slots.default}

      </div>
    </div>
  }
}
